export default "/_next/static/chunks/fonts/WhitneySSm-Book-Pro_Web-7e7744fcd4ea7542f8e6cea1257e2dc4.woff2";